
import { Button } from "@/components/ui/button";
import { Upload } from "lucide-react";

interface UploadButtonProps {
  onClick: () => void;
  disabled: boolean;
}

export function UploadButton({ onClick, disabled }: UploadButtonProps) {
  return (
    <Button 
      className="w-full" 
      onClick={onClick}
      disabled={disabled}
    >
      <Upload className="h-4 w-4 mr-2" /> Ανέβασμα Αρχείου
    </Button>
  );
}
